import type { ReactNode } from "react";
import { t } from "../i18n";
import { useHeroData } from "../state/heroData";
import { Spinner } from "./Spinner";

/**
 * Список серий там, где он нужен (страница героя, «Плеер»): пока не пришёл — загрузка,
 * не пришёл вовсе — ошибка с повтором. Пустое место вместо сезона выглядит как «серий нет».
 */
export function EpisodesBlock({ children }: { children: ReactNode }) {
  const { episodesReady, episodesError, reloadEpisodes } = useHeroData();
  if (episodesReady) return <>{children}</>;
  if (episodesError) {
    return (
      <div className="form__error load-error" role="alert">
        <span>{episodesError}</span>
        <button type="button" className="btn btn--outline btn--sm" onClick={() => void reloadEpisodes().catch(() => undefined)}>
          {t("app.retry")}
        </button>
      </div>
    );
  }
  return (
    <p className="muted loading-line">
      <Spinner size={18} /> {t("hero.episodesLoading")}
    </p>
  );
}
